export const getProductsFromCart = (products) => {
  return products.map((product) => {
    return {
      product_id: parseInt(product?.product_id || product?.productId),
      option_id: product?.productOptionValue?.id || product?.option_id,
      quantity: product.quantity_selected,
    };
  });
};
